import { useEffect, useState } from "react";
import "./top-listing-headers.css";
import SearchFilterInput from "../../form-fields/search-filter-input";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import SortIcon from "../../../assets/svgs/SortIcon";
import SingleDropdown from "../../singleDropdown/SingleDropdown";
import Chevren_downIcon from "../../../assets/svgs/Chevren_down";

interface ListingTopHeaderProps {
  className?: string;
  PageHeading?: string;
  ButtonName?: string;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  handleSort: (sortDirection: "asc" | "desc") => void;
  currentSortDirection: "asc" | "desc";
  handleFilterChange: (filter: string) => void;
  filterOptions: { title: string; count: number }[];
  activeFilter?: string;
  showAddButton?: boolean;
}

export default function UnitTopHeader({
  className = "",
  ButtonName,
  searchTerm,
  setSearchTerm,
  onClick,
  handleSort,
  currentSortDirection,
  handleFilterChange,
  filterOptions,
  activeFilter: activeFilterProp = "All",
  showAddButton = true,
}: ListingTopHeaderProps) {

  // Local mirror — instant highlight on click, no waiting for API
  const [activeFilter, setActiveFilter] = useState(activeFilterProp);
  useEffect(() => { setActiveFilter(activeFilterProp); }, [activeFilterProp]);
  const activeOption = filterOptions.find((option) => option.title === activeFilter);

  const handleFilterTabChange = (title: string) => {
    setActiveFilter(title);
    handleFilterChange(title);
  };

  return (
    <div className={`top-listing-header ${className}`}>
      <div className="top-listing-header-top">
        <H2 text="Units" />
        {ButtonName && showAddButton && (
          <SimpleButton label={ButtonName} onClick={onClick} />
        )}
      </div>

      <div className="top-listing-header-filters">
        {/* Desktop pills */}
        <div className="filter-options filters-desktop">
          {filterOptions.map((option) => (
            <button
              key={option.title}
              className={`filter-option${activeFilter === option.title ? " filter-option-active" : ""}`}
              onClick={() => handleFilterTabChange(option.title)}
            >
              {`${option.title} (${option.count})`}
            </button>
          ))}
        </div>

        <div className="search-sort-container">
          <SearchFilterInput
            placeholder="Search by Unit number"
            searchTerm={searchTerm}
            handleSearch={(e) => setSearchTerm(e.target.value)}
          />

          {/* Mobile dropdown */}
          <div className="filters-mobile">
            <SingleDropdown
              triggerText={`${activeFilter} (${activeOption?.count ?? 0})`}
              triggerIcon={<Chevren_downIcon width={"18"} height={"18"} />}
              triggerIconPosition="right"
              menuItems={filterOptions.map((option) => ({
                label: `${option.title} (${option.count})`,
                action: () => handleFilterTabChange(option.title),
              }))}
            />
          </div>

          <div
            className="sort-button"
            onClick={() => handleSort(currentSortDirection === "asc" ? "desc" : "asc")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) =>
              e.key === "Enter" &&
              handleSort(currentSortDirection === "asc" ? "desc" : "asc")
            }
          >
            <span className="sort-text">
              Sort by: {currentSortDirection === "asc" ? "A-Z" : "Z-A"}
            </span>
            <SortIcon />
          </div>
        </div>
      </div>
    </div>
  );
}